import { isEligibleForOrderType } from './isEligibleForOrderType';

export const isEligibleForPreOrder = (isEnabledForRestaurant, binaryCode, order_type) => {
  const isEligible = isEligibleForOrderType(binaryCode, order_type);
  return {
    prePaidEnabledfromShannon: isEnabledForRestaurant,
    enabledForOrderType: isEligible,
  };
};
